import React, { useEffect, useState } from "react";

// Local imports
import PageLoader from "../global/page-loader";
import CTAStrip from "../global/cta.strip";
import { route } from "../global/route.global";
import { months } from "../global/var.global";
import Img from "../widgets/Img";

// Live imports
import axios from "axios";
import parse from "html-react-parser";
import moment from "moment";
import Loader from "react-loader-spinner";

import { withRouter, NavLink as Link } from "react-router-dom";

function NewsElectricityRates() {
  const [searchOpen, setSearchOpen] = React.useState(false);
  const [ml, setMonthLists] = useState([
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [rates, setRates] = useState([]);

  const [years, setYears] = useState([]);
  const [year, setYear] = useState(0);
  const [month, setMonth] = useState(0);
  const [monthWord, setMonthWord] = useState("");
  const [genChargeLists, setGenChargeLists] = useState([]);

  useEffect(() => {
    setMonthYear();
    setYearsOptions();
    getGenChargeLists();
    getRateLists();
  }, [year, month]);

  const setMonthYear = () => {
    const date = new Date();

    if (year === 0 && month === 0) {
      setYear(date.getFullYear());
      setMonth(date.getMonth() + 1);
    }
  };

  const setYearsOptions = () => {
    const date = new Date();
    const _years = [];
    setYears([]);
    for (var i = 2007; i <= date.getFullYear(); i++) {
      _years.push(i);
    }
    setYears(_years);
  };

  const getRateLists = async () => {
    setRates([]);
    await axios
      .get(route.root.rates + `/official-rates/month/${month}/year/${year}`)
      .then(async (res) => {
        setRates(res.data.data.rates);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const toggleSearch = () => {
    setSearchOpen(!searchOpen);
  };

  const getGenChargeLists = async () => {
    await setGenChargeLists([]);
    await axios
      .get(route.root.rates + `/generation/month/${month}/year/${year}`)
      // .get(route.root.newsadvisory + "/generation-rates/" + m + "/" + y)
      .then(async (res) => {
        setGenChargeLists(res.data.data.charges);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onChangeMonth = async (e) => {
    setMonth(parseInt(e.target.value));
    setMonthWord(ml[parseInt(month) - 1]);
  };

  const onChangeYear = async (e) => {
    setYear(parseInt(e.target.value));
  };

  return (
    <>
      <PageLoader />
      <div className="breadcrumb-wrapper">
        <div className="images-overlay"></div>
        <div className="container">
          <div className="row">
            <div className="col-md-10">
              <div className="page-heading">
                <h1>Electricity Rates</h1>
                <span className="line"></span>
              </div>
              <div className="page-breadcrumb-inner">
                <div className="page-breadcrumb">
                  <div className="breadcrumb-list">
                    <ul>
                      <li>
                        <Link to="/" activeclassname="active">
                          Home
                        </Link>
                      </li>
                      <li>
                        <Link to="/news">News</Link>
                      </li>
                      <li>
                        <Link
                          exact
                          to="/news/advisories"
                          activeclassname="active"
                        >
                          Electricity Rates
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="blog-wrapper pt-5">
        <div className="container">
          {/**
          <div className="section_heading text-right">
            <p>
              <span className="mr-3"><i className="fa fa-filter"></i> Filter by: <span>Month</span> </span>  
              {(searchOpen)? <input type="text" className="mr-2 searchBox form-control" placeholder="Type here..."/> : null} 
              <span className="hover-pointer" onClick={toggleSearch}>
                {(searchOpen)? <i className="fa fa-close mr-2"></i> : <i className="fa fa-search mr-2"></i>}
                 Search </span> 
            </p>
          </div>**/}

          <div className="row">
            {isLoading ? (
              <div className="container">
                <div className="text-center">
                  <Loader
                    type="TailSpin"
                    color="#f10d08"
                    height={70}
                    width={70}
                    timeout={9000}
                  />
                  <h6>LOADING...</h6>
                </div>
              </div>
            ) : null}

            <div className="col-lg-10 col-md-10 col-sm-10">
              <h4>Rates</h4>
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>
                      Consumer Type ({ml[month - 1]} / {year})
                    </th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {rates.length > 0 ? (
                    rates.map((i, k) => {
                      return (
                        <tr key={k}>
                          <td>
                            <strong>
                              {i.type === "R"
                                ? "Residential"
                                : i.type === "LV"
                                  ? "Commercial"
                                  : i.type === "HV"
                                    ? "High Voltage"
                                    : ""}
                            </strong>
                          </td>
                          <td>
                            <strong>{i.amount}</strong>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="2" className="text-center">
                        <strong>No rates found for this month!</strong>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="col-lg-2 col-md-2 col-sm-2">
              <h5 className="text-center my-2">Year and Month</h5>
              <div className="form-group">
                <select
                  className="form-control"
                  value={year}
                  onChange={(e) => onChangeYear(e)}
                >
                  <option>Select Year</option>
                  {years
                    .sort((a, b) => b - a)
                    .map((i, k) => {
                      return (
                        <option value={i} key={k}>
                          {i}
                        </option>
                      );
                    })}
                </select>
              </div>
              <div className="form-group">
                <select
                  className="form-control"
                  value={month}
                  onChange={(e) => onChangeMonth(e)}
                >
                  <option>Select Month</option>
                  {ml.map((i, k) => {
                    return (
                      <option value={k + 1} key={k}>
                        {i}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="blog-wrapper pt-1 pl-5 pr-5">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <h3>Breakdown of Generation Charge</h3>
              <div className="table-fixed-header">
                <table className="table table-bordered table-hover rates-breakdown-table table-responsive ">
                  <thead>
                    <tr>
                      <th>
                        <p className="text-center mb-0">&nbsp;</p>
                        <p className="text-center mb-0">Sources</p>
                      </th>
                      <th>
                        <p className="text-center mb-0">&nbsp;</p>
                        <p className="text-center mb-0">
                          % to Total kWh Purchased
                        </p>
                      </th>
                      <th>
                        <p className="text-center mb-0">(A)</p>
                        <p className="text-center">kWh Purchased</p>
                      </th>
                      <th>
                        <p className="text-center mb-0">(B)</p>
                        <p className="text-center">
                          Basic Generation Cost (Php)
                        </p>
                      </th>
                      <th>
                        <p className="text-center mb-0">(C)</p>
                        <p className="text-center">
                          Other Cost Adjustment{" "}
                          <small>
                            (DAA, NSS, and other Billing Adjustment)
                          </small>{" "}
                          (Php)
                        </p>
                      </th>
                      <th>
                        <p className="text-center mb-0">(D = B + C)</p>
                        <p className="text-center">
                          Total Generation Cost for the Month (Php)
                        </p>
                      </th>
                      <th>
                        <p className="text-center mb-0">(E)</p>
                        <p className="text-center">
                          Prompt Payment Discount Availed less PPD Granted (Php)
                        </p>
                      </th>
                      <th>
                        <p className="text-center mb-0">(F)</p>
                        <p className="text-center">
                          Pilferage Cost Recoveries (Php)
                        </p>
                      </th>
                      <th>
                        <p className="text-center mb-0">(G)</p>
                        <p className="text-center">
                          Other Generation Cost Adjustment (OGA) (Php/kWh)
                        </p>
                      </th>
                      <th>
                        <p className="text-center mb-0">&nbsp;</p>
                        <p className="text-center">Generation Rate (Php/kWh)</p>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colSpan="10" className="text-center">
                        <p className="mb-0 text-bold">
                          {year} - {ml[month - 1]}
                        </p>
                      </td>
                    </tr>
                    {genChargeLists.length > 0 ? (
                      genChargeLists.map((i, k) => {
                        if (i.power_source.queue > 98) return;
                        return (
                          <tr
                            key={k}
                            className={` ${
                              i.power_source.queue === 20 ? "text-bold" : " "
                            }`}
                          >
                            <td>
                              <p className={`mb-0 `}>{i.power_source.name}</p>
                            </td>
                            <td>
                              <p className={`mb-0`}>
                                {i.percent_kwh_purchased}
                              </p>
                            </td>
                            <td>
                              <p className={`mb-0`}>{i.kwh_purchased}</p>
                            </td>
                            <td>
                              <p className={`mb-0`}>
                                {i.basic_generation_cost}
                              </p>
                            </td>
                            <td>
                              <p className={`mb-0`}>
                                {i.other_cost_adjustment}
                              </p>
                            </td>
                            <td>
                              <p className={`mb-0 `}>
                                {i.total_generation_cost}
                              </p>
                            </td>
                            <td>
                              <p className={`mb-0`}>
                                {i.prompt_payment_discount}
                              </p>
                            </td>
                            <td>
                              <p className={`mb-0`}>
                                {i.pilferage_cost_recoveries}
                              </p>
                            </td>
                            <td>
                              <p className={`mb-0`}>
                                {i.other_generation_cost_adjustment}
                              </p>
                            </td>
                            <td>
                              <p className={`mb-0 `}>{i.generation_rate}</p>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="10" className="text-center">
                          <strong>No generation charges data found!</strong>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {/*  */}
              <p className="text-sm">Note: VAT not included</p>
              <div className="table-fixed-header">
                <table className="table table-bordered table-hover  ">
                  <tbody>
                    {genChargeLists.length > 0 ? (
                      genChargeLists.map((i, k) => {
                        if (i.power_source.queue === 99) {
                          return i.other_details.map((x, y) => {
                            return (
                              <tr
                                key={k}
                                className={` ${
                                  i.power_source.queue === 20
                                    ? "text-bold"
                                    : " "
                                }`}
                              >
                                <td colSpan={1}>
                                  <p className={`mb-0 `}>
                                    <span>{x.title}</span>
                                  </p>
                                </td>
                                <td>
                                  <p className={`mb-0 `}>
                                    <span>{x.value}</span>
                                  </p>
                                </td>
                              </tr>
                            );
                          });
                        }
                      })
                    ) : (
                      <tr>
                        <td colSpan="10" className="text-center">
                          <strong>No generation charges data found!</strong>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {/*  */}
            </div>
          </div>
        </div>
      </section>

      <CTAStrip />
    </>
  );
}

export default withRouter(NewsElectricityRates);
